import classnames from 'classnames';
import { forwardRef } from 'react';

import styles from './TextArea.module.scss';
import { TextAreaProps } from './TextArea.types';

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, error, success, disabled, onChange, onValueChange, ...props }, ref) => {
    return (
      <textarea
        className={classnames(styles.textarea, className, {
          [styles.error]: error,
          [styles.success]: success,
          [styles.disabled]: disabled,
        })}
        disabled={disabled}
        onChange={event => {
          onChange?.(event);
          onValueChange?.(event.currentTarget.value);
        }}
        {...props}
        ref={ref}
      />
    );
  }
);
